import React from 'react';
import Icon from './icons/Icon';

/**
 * The Preview of a service that does not run: "<service> is stopped" with Start, or "Starting <service>…" once
 * something started it (this Start, the header's Start all, Home, an AI tool). Canvas swaps it for the app's iframe
 * as soon as the shared service state says the service is ready (usePreviewWatchdog / followPreviewTabs), so the
 * iframe never shows stale content of a stopped app, nor the runner's 503 page.
 *
 * @param {object} props
 * @param {string} props.serviceName
 * @param {boolean} [props.starting] started, not ready yet
 * @param {boolean} [props.canRun] false for a viewer: the state without the Start button
 * @param {string|null} [props.startError] why the last Start was refused
 * @param {() => void} props.onStart
 */
export default function PreviewStoppedState({ serviceName, starting = false, canRun = true, startError = null, onStart }) {
  if (starting) {
    return (
      <div className="preview-loading preview-starting-state" role="status">
        <div className="loading-spinner" />
        <p>{`Starting ${serviceName}…`}</p>
      </div>
    );
  }
  return (
    <div className="preview-empty-service-state preview-stopped-state" role="status" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, gap: '12px', textAlign: 'center', padding: '24px' }}>
      <Icon name="pause" size={32} />
      <h3 style={{ margin: 0 }}>{`${serviceName} is stopped`}</h3>
      <p style={{ margin: 0, maxWidth: '360px', opacity: 0.8 }}>
        {canRun
          ? 'Start it to see the app here. It starts again with its latest code.'
          : 'Ask the project owner to start it.'}
      </p>
      {startError && <p className="preview-stopped-error" role="alert" style={{ margin: 0, maxWidth: '360px' }}>{startError}</p>}
      {canRun && (
        <button className="preview-error-btn preview-error-btn-retry" onClick={onStart} type="button">
          <Icon name="play" size={14} glow={false} /> {'Start the app'}
        </button>
      )}
    </div>
  );
}
